import { useEffect, useRef } from "react";
import _ from "lodash";

type  Props = {
  chartType: string;
  chartConfig: any;
}

const LineBaseConfig = {
  legend: {
    orient: 'horizontal',
    align: 'left'
  },
  backgroundColor: "transparent",
  grid: {
    left: '10',
    right: '10',
    bottom: '10',
    top: '20',
    containLabel: true
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    type: 'value',
  },
  tooltip: {
    trigger: 'axis',
  },
};

const BarBaseConfig = {
  legend: {
    orient: 'horizontal',
    align: 'left'
  },
  backgroundColor: "transparent",
  grid: {
    left: '10',
    right: '10',
    bottom: '10',
    top: '20',
    containLabel: true
  },
  xAxis: {
    type: 'category',
  },
  yAxis: {
    type: 'value',
  },
  tooltip: {
    trigger: 'axis',
  },
}


const PieBaseConfig = {
  backgroundColor: 'transparent',
  tooltip: {
    trigger: 'item',
  },
}

const RadarBaseConfig = {
  backgroundColor: "transparent",
  tooltip: {
    trigger: 'item',
  },
}

export default function BaseChart(props: Props) {
  const chartDomRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (chartDomRef.current) {
      // @ts-ignore
      chartRef.current = echarts.init(chartDomRef.current, "light", {
        locale: "ZH"
      });
    }

    return ()=>{
      if(chartRef.current){
        chartRef.current.dispose()
      }
    }
  }, []);


  // 添加自适应尺寸的代码
  useEffect(() => {
    if (!chartDomRef.current) return;

    const handleResize = () => {
      chartRef.current.resize();
    };

    // 监听容器尺寸变化
    const resizeObserver = new ResizeObserver(handleResize);
    if (chartRef.current) {
      resizeObserver.observe(chartDomRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  useEffect(() => {
    let baseConfig = {};
    switch (props.chartType) {
      case "line": {
        baseConfig = _.cloneDeep(LineBaseConfig);
        break;
      }
      case "bar": {
        baseConfig = _.cloneDeep(BarBaseConfig);
        break;
      }
      case "pie": {
        baseConfig = _.cloneDeep(PieBaseConfig);
        break;
      }
      case "radar": {
        baseConfig = _.cloneDeep(RadarBaseConfig);
        break;
      }
    }

    baseConfig = Object.assign(baseConfig, props.chartConfig);

    if (chartRef.current) {
      chartRef.current.clear();
      chartRef.current.resize();
      chartRef.current.setOption(baseConfig);
    }

  }, [props.chartType, props.chartConfig]);

  return <div
    ref={chartDomRef}
    style={{ width: "100%", height: "100%" }}
  >
  </div>;
}